'use strict';

angular.module('mean.trades').controller('TradeProjectEditOptionsController', ['$scope', 'MeanUser', 'Global', 'Bids', '$filter', 'Units', '$q', 'toaster', 'NotifyService', 'BidRequestEdit', '$location', 'Materials', 'Equipments', 'bidPlanCodeService', 'tradeCodeService', 'taskTotalsService', 'Trades', 'userService', 'Subtasks', 'TradeBids', 'ngDialog', 'bidTotalsService', 'bidRequestEditService', 'tradeService', 'tradeOptionsService', 'taskListService', 'Options', 'GeneralTasks', '$rootScope', 'optionPlanService',
  function($scope, MeanUser, Global, Bids, $filter, Units, $q, toaster, NotifyService, BidRequestEdit, $location, Materials, Equipments, bidPlanCodeService, tradeCodeService, taskTotalsService, Trades, userService, Subtasks, TradeBids, ngDialog, bidTotalsService, bidRequestEditService, tradeService, tradeOptionsService, taskListService, Options, GeneralTasks, $rootScope, optionPlanService) {
    $scope.global = Global;

    $scope.user = MeanUser.user;

    $scope.plans = [];
    $scope.available_materials = [];
    $scope.available_categories = [];
    $scope.available_equipments = [];
    $scope.available_equipment_categories = [];
    $scope.original_bid_subtasks = [];
    $scope.unitEditing = false;
    $scope.matrix_values = [];
    $scope.all_tasks = [];
    $scope.materialEditId = -1;
    $scope.equipmentEditId = -1;
    $scope.currentRevision = null;
    $scope.main_account_id = null;

    console.log('TradeProjectEditOptionsController');

    Units.query({}, function(units) {
        $scope.units = units
    });

    $scope.$on('$addToBidOptions', function(event, data) {
        console.log('in the options addToBidOptions and have the project');
        //$scope.bid.options.push(data);
        $scope.my_options = $scope.$parent.trade_options;
        $scope.selectedItem = $scope.$parent.selectedItem;
        $scope.ordered_lots = $scope.$parent.ordered_lots;
        $scope.buildCurrentOptions();
        $scope.matrix_values = [];

        $scope.my_options.options = tradeOptionsService.filterTrade(
                $scope.my_options.options, $scope.user.trade[0]);

        // var current_list = $filter('filter')($scope.bid_list, {
        //     'revision': $scope.current_option.bid_revision }, true);

        // $scope.original_bid_subtasks =
        //     tradeOptionsService.getBidSubtasks(
        //         $scope.my_bid, current_list);

        _.each($scope.my_options.options, function(itemx) {
            $scope.selectCurrentOption(itemx);
            _.each($scope.plans, function(itemy) {
                optionPlanService.buildPlan(itemy, itemx,
                    $scope.matrix_values, $scope.user.trade[0]);
            });
        });
        _.each($scope.my_options.options, function(itemx) {
            _.each($scope.plans, function(itemy) {
                optionPlanService.planTotal(itemy, itemx,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            });
        });

        $scope.current_option = {};
    });

    $scope.$on('$removeFromBidOptions', function(event, data) {
        console.log('in the options removeFromBidOptions and have the project');
        $scope.my_options = $scope.$parent.trade_options;
        $scope.selectedItem = $scope.$parent.selectedItem;
        $scope.ordered_lots = $scope.$parent.ordered_lots;
        $scope.buildCurrentOptions();
        $scope.matrix_values = [];

        $scope.my_options.options = tradeOptionsService.filterTrade(
            $scope.my_options.options, $scope.user.trade[0]);

        // var current_list = $filter('filter')($scope.bid_list, {
        //     'revision': $scope.current_option.bid_revision }, true);

        // $scope.original_bid_subtasks =
        //     tradeOptionsService.getBidSubtasks(
        //         $scope.my_bid, current_list);

        _.each($scope.my_options.options, function(itemx) {
            $scope.selectCurrentOption(itemx);
            _.each($scope.plans, function(itemy) {
                optionPlanService.buildPlan(itemy, itemx,
                    $scope.matrix_values, $scope.user.trade[0]);
            });
        });
        _.each($scope.my_options.options, function(itemx) {
            _.each($scope.plans, function(itemy) {
                optionPlanService.planTotal(itemy, itemx,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            });
        });

        $scope.current_option = {};
    });

    $scope.$on('$updateOptionName', function(event, data) {
        console.log('in the options addToBidOptions and have the project');
        //$scope.bid.options.push(data);
        $scope.matrix_values = $scope.$parent.matrix_values;
        $scope.current_option = {};
    });

    $scope.$on('$updateOption', function(event, data) {
        $scope.my_options = data;
        $scope.current_option = {};
    });

    $scope.isOptionActive = function(opt, plan) {
        var active = false;
        if(!$scope.currentRevision) {
            toaster.pop('error', 'Option Revision Error',
                'Please select an option an the revision before trying to edit a total.')
            return true;
        }
        _.each($scope.selectedItem.lots, function(lot) {
            var inlist = $filter('filter')(lot.active_options,
                { 'number': opt }, true);

            if(inlist.length > 0) {
                var tradeOpt = $filter('filter')(inlist[0].totals, {'trade': $scope.user.trade[0]}, true)[0];

                if(tradeOpt &&
                    tradeOpt.option_revision === $scope.currentRevision.number) {

                    if(!plan) return true;

                    if(lot.plan === plan)
                        active = true;
                }
            }
        });

        return active;
    };

    $scope.idSelectedVote = null;
    $scope.setSelected = function (idSelectedOption) {
        $scope.idSelectedOption = idSelectedOption;
    };

    $scope.init = function() {

        $scope.selectedItem = $scope.$parent.selectedItem;
        $scope.ordered_lots = $scope.$parent.ordered_lots;
        $scope.bid_tasks = $scope.$parent.bid_tasks;
        $scope.builders = $scope.$parent.builders;
        $scope.is_admin = $scope.$parent.is_admin;
        $scope.is_builder = $scope.$parent.is_builder;
        $scope.plans = $scope.$parent.plans;
        $scope.my_bid = $scope.$parent.trade_bids[0];
        $scope.bid = $scope.$parent.bid;
        $scope.can_edit = $scope.$parent.can_edit;
        $scope.bid_revisions_to_include = $scope.$parent.bid_revisions_to_include;
        $scope.trade_bid = $filter('filter')($scope.bid.bidding_trades, {
            'trade': $scope.my_trade.trade }, true)[0];
        $scope.matrix_values = $scope.$parent.matrix_values;

        if(!$scope.trade_bid) {
            toaster.pop('error', 'Trade Bid Error', 'Problem getting the trade bid.  Contact Admin');
            return;
        }

        $scope.bid_list = $scope.trade_bid.bid_list;

        //$scope.original_bid_subtasks = $scope.$parent.original_bid_subtasks;
        $scope.my_options = $scope.$parent.trade_options;

        if($scope.$parent.trade_bids.length !== 1) {
            toaster.pop({
                type: 'warning',
                title: 'Trade Bid',
                body: 'Issue getting trade bid that is most likely due to no bid association.  ' +
                    'If that is the case, make the required association to add options.  ' +
                    'If the association has already been made, contact admin.',
                timeout: 0,
                showCloseButton: true,
                tapToDismiss: false
                //closeHtml: '<button>Close</button>'
            });

            return;
        }

        var inlist = $filter('filter')($scope.builders, {
            'trade': $scope.user.trade[0],
            'company_code': $scope.user.company_code}, true);

        if(inlist.length === 1) {
            $scope.my_trade = inlist[0];
            // filter subtask of trade
            var subtaskOptions = $filter('filter')($scope.my_trade.subtasks, {
                    'projectType': $scope.bid.projectType,
                    'geoLocation': $scope.bid.geoLocation
            }, true);
            $scope.my_trade.subtasks = subtaskOptions;
        } else {
            toaster.pop('error', 'Trade', 'Issue getting trade info.  Contact Admin');
            return;
        }

        if(!$scope.my_bid.costs) {
            $scope.my_bid.costs = $scope.my_trade.costs;
        }

        $scope.plans = [];

        _.each($scope.selectedItem.plan_codes, function(plan) {
            $scope.plans.push(plan.item);
        });

        // $scope.options = tradeOptionsService.filterTrade(
        //     $scope.bid.options, $scope.user.trade[0]);
        $scope.my_options.options = tradeOptionsService.filterTrade(
            $scope.my_options.options, $scope.user.trade[0]);

        _.each($scope.my_options.options, function(itemx) {
            //$scope.selectCurrentOption(itemx);
            _.each($scope.plans, function(itemy) {
                optionPlanService.buildPlan(itemy, itemx,
                    $scope.matrix_values, $scope.user.trade[0]);
            });
        });

        if($scope.my_bid.supplier) {
            $scope.getMaterial();
        }

        if($scope.my_bid.equipment_supplier) {
            $scope.getEquipment();
        }

        userService.getMainAccount($scope.user.username).then(function (user) {
            $scope.main_account_id = user._id;
            GeneralTasks.query({
                'trade': tradeCodeService.getCode($scope.user.trade[0]),
                'projectType': $scope.bid.projectType,
                'geoLocation': $scope.bid.geoLocation,
                'isCustom': $scope.bid.isCustom || false,
                'userId': $scope.bid.userId || ''
            }, function(tasks) {

                $scope.all_tasks = $filter('orderBy')(tasks, 'order');

                for(var i=0; i<$scope.all_tasks.length; i++) {
                    var subs = $filter('filter')($scope.my_trade.subtasks, {
                            'task': $scope.all_tasks[i].task,
                            'projectType': $scope.bid.projectType,
                            'geoLocation': $scope.bid.geoLocation
                    }, true);

                    $scope.all_tasks[i].subtasks = subs;
                }
            });
        });

        $scope.current_option = {};
    };

    $scope.updatePlanTotals = function(rev) {
        $scope.currentRevision = rev;

        if(!$scope.currentRevision) {
            $scope.can_edit = false;
            return;
        }

        ($scope.current_option.revisions.length === $scope.currentRevision.number)?
            $scope.can_edit=true:$scope.can_edit=false;
    };

    $scope.getRevPlanTotal = function(rev, plan) {
        var obj = optionPlanService.planOptionRevisionTotal(plan, $scope.current_option, $scope.matrix_values,
            $scope.trade_bids[0].bid_list, $scope.user.trade[0], rev);

        if(obj)
          return obj[0].value;
    };

    $scope.getMaterial = function() {
        if(!$scope.my_bid.supplier) {
            //there is no main supplier set so we're going to
            //set with the first supplier we find in the first material
            $scope.material_supplier =
                $scope.bid_list[0].subtasks[0].materials[0].supplier;
        } else {
            $scope.material_supplier = $scope.my_bid.supplier;
        }

        Materials.query({
            'trade_account': $scope.my_trade._id ,
            'supplier': $scope.material_supplier,
            'userId': $scope.main_account_id
        }, function(materials) {
            $scope.available_materials = materials;
            $scope.available_materials.forEach(function(material, idx) {

                var in_list = $filter('filter')($scope.available_categories, {
                    name: material.category}, true);
                if(in_list.length === 0) {
                    $scope.available_categories.push({
                        name: material.category
                    });
                }
            });
        });
    }

    $scope.getEquipment = function() {
        if(!$scope.my_bid.equipment_supplier) {
            //there is no main supplier set so we're going to
            //set with the first supplier we find in the first material
            $scope.equipment_supplier =
                $scope.bid_list[0].subtasks[0].equipment[0].supplier;
        } else {
            $scope.equipment_supplier = $scope.my_bid.equipment_supplier;
        }

        Equipments.query({ 'trade_account': $scope.my_trade._id ,
                supplier: $scope.equipment_supplier}, function(equipments) {
            $scope.available_equipments = equipments;
            $scope.available_equipments.forEach(function(equipment, idx) {

                var in_list = $filter('filter')($scope.available_equipment_categories, {
                    name: equipment.category}, true);
                if(in_list.length === 0) {
                    $scope.available_equipment_categories.push({
                        name: equipment.category
                    });
                }
            });
        });
    };

    $scope.setTaskEditId =  function(pid) {
        $scope.taskEditId = pid;
    };

    $scope.setMaterialEditId =  function(pid) {
        $scope.materialEditId = pid;
    };

    $scope.setEquipmentEditId =  function(pid) {
        $scope.equipmentEditId = pid;
    };

    $scope.selectCurrentOption =  function(item, idx) {
        $scope.idSelectedOption = idx;
        var found = $filter('filter')($scope.my_options.options, {
            'number': item.number }, true);
        $scope.current_option = found[0];
    };

    $scope.selectCurrentOptionFromView =  function(item, idx) {
        $scope.idSelectedOption = idx;
        var found = $filter('filter')($scope.my_options.options, {
            'number': item.number }, true);
        $scope.current_option = found[0];

        if(angular.isArray($scope.bid_list) && $scope.bid_list.length > 0) {
            var current_list = $filter('filter')($scope.bid_list, {
                'revision': $scope.current_option.bid_revision }, true);

            $scope.original_bid_subtasks =
                tradeOptionsService.getBidSubtasks(
                    $scope.my_bid, current_list);

            $scope.currentRevision =
                $scope.current_option.revisions[$scope.current_option.revisions.length-1];
        } else {
            toaster.pop('error', 'Bid List Not Built',
                'The bid list is not filled in.  Do an F5 refresh.  If that does not work, contact admin.');
        }
    };

    $scope.revisionChanged = function(rev) {
        // if(!rev) {
        //     this.currentRevision = $scope.currentRevision;
        //     return;
        // }

        // $scope.currentRevision = this.currentRevision = rev;
    };

    $scope.addRevision = function() {
        //get a copy of all the current subtasks
        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number}, true)[0];

        var current_revision = $scope.current_option.revisions.length;

        if(!option) {
            toaster.pop('error', 'Option Error', 'Problem finding the option.');
        }
        var rev_subtasks = $filter('filter')(option.subtasks, {'revision': current_revision}, true);

        _.each(rev_subtasks, function(sub) {
            //deep copy the subtask
            var subtask = angular.copy(sub);
            //strip the _id for saving
            tradeOptionsService.stripId(subtask);
            //time is used to control the view to make sure we don't show
            //3 subtasks (one for each plan) for instance.
            subtask.time = sub.time + 1;
            //add the new subtask to the option subtask list
            option.subtasks.push(subtask);
            //increment the option revision of this subtask
            sub.revision = current_revision + 1;
        });

        //add the new revision to the main tracking list
        option.revisions.push({
            number: current_revision + 1
        });

        //$scope.curr_before_save = $scope.current_option;

        $scope.my_options.$update(function(res) {
            var saved_opt = $filter('filter')(res.options, {
                'number': option.number}, true)[0];

            var opt = $filter('filter')($scope.my_options.options, {
                'number': option.number}, true)[0];
            opt = saved_opt;
            $scope.current_option = saved_opt;
            $scope.currentRevision = saved_opt.revisions[saved_opt.revisions.length-1];
            //$scope.setRevisionsForView();
            toaster.pop('success', 'Revision Added');
        }, function(error) {
            $location.path('/');
            toaster.pop('error', 'Add Revision Error', 'Problem saving the option revision data.');
        });
    };

    $scope.addRevisionOperation = function() {
        ngDialog.openConfirm({
            template:
                '<h2>Add Revision Confirm</h2>' +
                '<p>This will create a new revision for this option.</p>' +
                '<p>This operation cannot be undone </p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            $scope.addRevision();
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.onSubtaskSelect = function(selected_subtask) {
        $scope.current_subtask = selected_subtask;
    };

    $scope.getPlanQuantity = function(item, plan) {
        if($scope.current_option.plans.indexOf(plan) === -1) return;

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            return 0;
        }

        var me = $filter('filter')(option[0].subtasks, {
            'plan': plan, 'time': item.time, task: item.task,
            'revision': (this.currentRevision)?this.currentRevision.number:1 }, true);

        this.plan_item = (me[0]) ? me[0].quantity : 0;

        return (me[0]) ? me[0].quantity : 0;
    };

    // $scope.getFailedLots(plan) {
    //     var lots = [];
    //     var plan_lots = $filter('filter')($scope.selectedItem.lots, {'plan': plan}, true);

    //     _.each(plan_lots, function(pL) {
    //         var trade_options = $filter('filter')(pL.active_options, {'number'})
    //     })
    // }

    $scope.updateTask = function(value, item, plan) {
        if($scope.isOptionActive($scope.current_option.number, plan)) {
            this.plan_item = item.quantity;


            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            toaster.pop('error', 'Option Number Error',
                'Unable to find option number ' + $scope.current_option.number +
                '.  Verify option number exists.');
            return;
        }

        var sub = $filter('filter')(option[0].subtasks, {
            'plan': plan, 'time': item.time,
            'revision': (this.currentRevision)?this.currentRevision.number:1 }, true);

        if(sub.length !== 1) {
            toaster.pop('error', 'No Subtask Found',
                'updateTask could not find a valid subtask to update.');
            return;
        } else {
            sub[0].quantity = Number(value);
            // _.each(sub[0].materials, function(mat) {
            //     mat.quantity = 0;
            // });

            taskTotalsService.getSubtaskCalculations(
                sub,
                $scope.my_bid.costs);

            tradeOptionsService.stripId(sub[0]);

            $scope.my_options.$update(function(res) {
                $rootScope.$broadcast('$updateOptionSubtask', res);
                //$scope.updateCurrentOption();
                for(var j=0; j<$scope.plans.length; j++) {
                    // var current_list = $filter('filter')($scope.bid_list, {
                    //     'revision': $scope.current_option.bid_revision }, true);

                    // $scope.original_bid_subtasks =
                    //     tradeOptionsService.getBidSubtasks(
                    //         $scope.my_bid, current_list);
                    optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                        $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
                }
                toaster.pop('success', 'Bid Database', 'Subtask Quantity Updated.');
            }, function(error) {
                toaster.pop('error', 'Bid Database', 'Problem saving the subtask quantity data.');
            });
        }
    };

    $scope.editCurrentValue = function (item) {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }
        item.currentValueEditing = true;
    };

    $scope.doneEditingCurrentValue = function (item) {
        if(!item.currentValueEditing) return;

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        //var subs = $filter('filter')(option[0].subtasks, {
        //    'plan': item.plan }, true);

        var current_value = item.option - item.original;
        var amount = parseFloat(item.value) - current_value;
        var time = new Date().getTime();
        var idx = option[0].plans.indexOf(item.plan);

        if(idx === -1) {
            toaster.pop('error', 'Option Plan',
                'Could not find plan in option.');
            return;
        }

        //var plan = option[0].plans[idx];
        var task = angular.copy($scope.all_tasks[$scope.all_tasks.length-1]);
        var cp_sub = angular.copy(task.subtasks[task.subtasks.length-1]);

        //we need to see if we've already added an override for this
        //plan.  If so, lets just update the number else add a new sub.
        var inlist = $filter('filter')(option[0].subtasks, {'code': cp_sub.code,
            'is_overridden': true, 'plan': item.plan, 'revision': $scope.currentRevision.number }, true);
        // var inlist = $filter('filter')(subs, {'code': sub.code }, true);

        if(inlist.length === 0) {
            _.each(option[0].plans, function(plan) {
                var sub = angular.copy(cp_sub);
                sub.active = false;
                sub.bid_hours = 0;
                sub.hours_allowed = 0;
                if(plan == item.plan) {
                    sub.is_overridden = true;
                    sub.overridden_total = amount;
                } else {
                    sub.is_overridden = true;
                    sub.overridden_total = 0;
                }
                sub.plan = plan;
                sub.quantity = 0;
                sub.revision = $scope.currentRevision.number;
                sub.subtask_array_id = task.subtasks.length-1;
                sub.time = time
                sub.total = 0;
                sub.trade_id = $scope.my_bid._id;
                delete sub._id;
                option[0].subtasks.push(sub);
            });
        } else if(inlist.length === 1) {
            inlist[0].is_overridden = true;

            //this will happen if the last subtask has been
            //added by the user but then the user overrides
            //this option.
            if(inlist[0].total !== 0) {
                inlist[0].overridden_total += inlist[0].total;
                inlist[0].total = 0;
            }

            inlist[0].overridden_total += amount;
        } else {
            toaster.pop('error', 'Too Many Overrides Found',
                'Contact Admin');
            return;
        }


        console.log($scope.my_options);

        $scope.my_options.$update(function(res) {
            $rootScope.$broadcast('$updateOptionSubtask', res);
            //$scope.current_option = option[0];
            //$scope.updateCurrentOption();
            for(var j=0; j<$scope.plans.length; j++) {
                // var current_list = $filter('filter')($scope.bid_list, {
                //     'revision': $scope.current_option.bid_revision }, true);

                // $scope.original_bid_subtasks =
                //     tradeOptionsService.getBidSubtasks(
                //         $scope.my_bid, current_list);
                optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Quantity Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask quantity data.');
        });

        item.currentValueEditing = false;
    };

    $scope.editCrewRate = function (item) {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }
        item.crewRateEditing = true;
    };

    $scope.doneCrewRateEditing = function (item) {
        if(!item.crewRateEditing) return;

        $scope.updateSubtask(item);

        item.crewRateEditing = false;
    };

    $scope.editPieceRate = function (item) {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        if(item.piece_per_hour_rate !== 0) {
            alert('You must clear out Piece/Hour Rate first.');
            return;
        }

        item.crewPieceRateEditing = true;
    };

    $scope.donePieceRateEditing = function (item) {
        if(!item.crewPieceRateEditing) return;

        $scope.updateSubtask(item);

        item.crewPieceRateEditing = false;
    };

    $scope.editPiecePerHourRate = function (item) {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        if(item.piece_rate !== 0) {
            alert('You must clear out Piece Rate first.');
            return;
        }

        item.crewPiecePerHourRateEditing = true;
    };

    $scope.donePiecePerHourRateEditing = function (item) {
        if(!item.crewPiecePerHourRateEditing) return;

        $scope.updateSubtask(item);

        item.crewPiecePerHourRateEditing = false;
    };

    $scope.editUnits = function (item) {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        item.unitEditing = true;
    };

    $scope.doneUnitEditing = function (item) {
        if(!item.unitEditing) return;

        item.unitEditing = false;
        item.unit = item.unit.unit;
        $scope.updateSubtask(item);
    };

    $scope.updateSubtask = function(item) {
        if(!item.piece_per_hour_rate) item.piece_per_hour_rate = 0;
        if(!item.piece_rate) item.piece_rate = 0;

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var subs = $filter('filter')(option[0].subtasks, {
            'time': item.time }, true);

        _.each(subs, function(sub) {
            sub.crew_rate = Number(item.crew_rate);
            sub.piece_per_hour_rate = Number(item.piece_per_hour_rate);
            sub.piece_rate = Number(item.piece_rate);
            sub.piece_per_size = Number(item.piece_per_size);
            sub.unit = item.unit;
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            //$scope.updateCurrentOption();  this function is resetting current_subtask
            $rootScope.$broadcast('$updateOptionSubtask', res);
            for(var j=0; j<$scope.plans.length; j++) {
                // var current_list = $filter('filter')($scope.bid_list, {
                //     'revision': $scope.current_option.bid_revision }, true);

                // $scope.original_bid_subtasks =
                //     tradeOptionsService.getBidSubtasks(
                //         $scope.my_bid, current_list);
                optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });
    };

    $scope.addBidSubtask = function(selected_subtask) {
        this.selected_subtask = '';

        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        if(!$scope.current_option || !$scope.current_option.plans) {
            toaster.pop('warning', 'Option Not Selected',
                'You must select an option before adding a subtask');
            return;
        }

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            toaster.pop('error', 'Option Not Returning',
                'Did not find the option needed.  Contact admin.');
            return;
        }

        //get the most current bid revision to add
        var bids = $filter('filter')($scope.bid_list, {
            'task': selected_subtask.task,
            'trade': selected_subtask.trade }, true);

        var bid_revs = $filter('unique')(bids, 'revision');

        //$scope.bid_list is all the bid revisions based off of
        //what the options are concerned with so it can be more than one
        if(bid_revs.length > 1) {
            bid_revs = $filter('orderBy')(bid_revs, 'revision');
            bids = $filter('filter')(bids, {
                'revision': bid_revs[bid_revs.length-1].revision }, true);
        }

        var time = new Date().getTime();
        var revision = (this.currentRevision)?this.currentRevision.number:1;

        _.each(bids, function(bid) {
            if(option[0].plans.indexOf(bid.plan) !== -1) {
                _.each(bid.subtasks, function(subtask) {
                    if(subtask._id === selected_subtask._id) {
                        option[0].subtasks.push(angular.copy(subtask));
                        option[0].subtasks[option[0].subtasks.length-1].plan = bid.plan;
                        option[0].subtasks[option[0].subtasks.length-1].trade_id = $scope.my_bid._id;
                        option[0].subtasks[option[0].subtasks.length-1].time = time;
                        option[0].subtasks[option[0].subtasks.length-1].revision = revision;
                        option[0].subtasks[option[0].subtasks.length-1].subtask_array_id = subtask._id;
                        option[0].subtasks[option[0].subtasks.length-1].bid_subtask = true;
                        _.each(subtask.materials, function(material, i) {
                            option[0].subtasks[option[0].subtasks.length-1].materials[i].material_id = material._id;
                        });
                        _.each(subtask.equipment, function(equipment, i) {
                            option[0].subtasks[option[0].subtasks.length-1].equipment[i].equipment_id = equipment._id;
                        });
                        tradeOptionsService.stripId(option[0].subtasks[option[0].subtasks.length-1]);
                    }
                });
            }
        });

        $scope.my_options.$update(function(res) {
            var saved_opt = $filter('filter')(res.options, {
                'number': option[0].number}, true)[0];

            var opt = $filter('filter')($scope.my_options.options, {
                'number': option[0].number}, true)[0];
            opt = saved_opt;
            $scope.current_option.subtasks = saved_opt.subtasks;

            //$scope.current_option = option[0];
            //$scope.updateCurrentOption();
            for(var j=0; j<$scope.plans.length; j++) {
                // var current_list = $filter('filter')($scope.bid_list, {
                //     'revision': $scope.current_option.bid_revision }, true);

                // $scope.original_bid_subtasks =
                //     tradeOptionsService.getBidSubtasks(
                //         $scope.my_bid, current_list);
                optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            }
            toaster.pop('success', 'Option Saved', 'Option saved to database');
        }, function(error) {
            toaster.pop('error', 'Option Save Error', error);
        });
    };

    $scope.removeTaskOption = function(item) {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        console.log('removeTaskOption');
        if(!$scope.current_option || !$scope.current_option.plans) {
            toaster.pop('warning', 'Option Not Selected',
                'You must select an option before removing a subtask');
            return;
        }

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            toaster.pop('error', 'Option Not Returning',
                'Did not find the option needed.  Contact admin.');
            return;
        }

        var list_item = $filter('filter')(option[0].subtasks, {
            'time': item.time }, true);

        for(var i=list_item.length-1; i>=0; i--) {
            var idx = option[0].subtasks.indexOf(list_item[i]);
            option[0].subtasks.splice(idx, 1);
        }

        // var current_list = $filter('filter')($scope.bid_list, {
        //     'revision': $scope.current_option.bid_revision }, true);

        // $scope.original_bid_subtasks =
        //     tradeOptionsService.getBidSubtasks(
        //         $scope.my_bid, current_list);

        for(var j=0; j<$scope.plans.length; j++) {
            optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
        }

        $scope.my_options.$update(function(res) {
            var saved_opt = $filter('filter')(res.options, {
                'number': option[0].number}, true)[0];

            var opt = $filter('filter')($scope.my_options.options, {
                'number': option[0].number}, true)[0];
            opt = saved_opt;
            $scope.current_option.subtasks = saved_opt.subtasks;

            // for(var j=0; j<$scope.plans.length; j++) {
            //     optionPlanService.planTotal($scope.plans[j], $scope.current_option,
            //         $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            // }
            toaster.pop('success', 'Option Saved', 'Option saved to database');
        }, function(error) {
            toaster.pop('error', 'Option Save Error', error);
        });
    };

    $scope.addSystemSubtask = function(sub) {
        this.selected_subtask = '';

        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        if(!$scope.current_option) {
            toaster.pop('warning', 'Option Not Selected',
                'You must select an option before adding a subtask');
            return;
        }

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            toaster.pop('error', 'Option Not Returning',
                'Did not find the option needed.  Contact admin.');
            return;
        }

        //sub is the system subtask but we need to see if we have an
        //overridden subtask in our tradeBid.
        var inlist = $filter('filter')($scope.my_trade.subtasks, {
            'subtask_id': sub._id}, true);

        // get the task from the system task list
        var task_item = $filter('filter')($scope.all_tasks, {
            'trade': sub.trade, 'task': sub.task }, true);

        if(task_item.length !== 1) {
            toaster.pop('error', 'Problem Getting Task',
                'Could not get task from task_list.  Contact Admin.');
            return;
        }

        var sub_index = task_item[0].subtasks.indexOf(sub);

        var time = new Date().getTime();
        var value = {};
        if(inlist.length === 1) {
            value = {
                _id: task_item[0].subtasks.length,
                trade_id: $scope.my_bid._id,
                code: sub.code,
                time: time,
                revision: (this.currentRevision)?this.currentRevision.number:1,
                trade: sub.trade,
                task: sub.task,
                name: sub.name,
                unit: sub.unit,
                subtask_id: inlist[0].subtask_id,
                piece_rate: inlist[0].piece_rate,
                crew_rate: inlist[0].crew_rate,
                piece_per_hour_rate: inlist[0].piece_per_hour_rate,
                quantity: 0,
                bid_hours: 0,
                hours_allowed: 0,
                total: 0,
                bid_total: 0
            }
        } else {
            value = {
                _id: task_item[0].subtasks.length,
                trade_id: $scope.my_bid._id,
                code: sub.code,
                time: time,
                revision: (this.currentRevision)?this.currentRevision.number:1,
                trade: sub.trade,
                task: sub.task,
                name: sub.name,
                unit: sub.unit,
                subtask_id: sub._id,
                piece_rate: sub.piece_rate,
                crew_rate: sub.crew_rate,
                piece_per_hour_rate: sub.piece_per_hour_rate,
                quantity: 0,
                bid_hours: 0,
                hours_allowed: 0,
                total: 0,
                bid_total: 0
            }
        }

        _.each(option[0].plans, function(plan) {
            option[0].subtasks.push(angular.copy(value));
            option[0].subtasks[option[0].subtasks.length-1].plan = plan;
            option[0].subtasks[option[0].subtasks.length-1].subtask_array_id = sub_index;

            tradeOptionsService.stripId(option[0].subtasks[option[0].subtasks.length-1]);
        });

        $scope.my_options.$update(function(res) {
            var saved_opt = $filter('filter')(res.options, {
                'number': option[0].number}, true)[0];

            var opt = $filter('filter')($scope.my_options.options, {
                'number': option[0].number}, true)[0];
            opt = saved_opt;
            $scope.current_option.subtasks = saved_opt.subtasks;

            //$scope.current_option = option[0];
            //$scope.updateCurrentOption();
            // var current_list = $filter('filter')($scope.bid_list, {
            //     'revision': $scope.current_option.bid_revision }, true);

            // $scope.original_bid_subtasks =
            //     tradeOptionsService.getBidSubtasks(
            //         $scope.my_bid, current_list);
            for(var j=0; j<$scope.plans.length; j++) {
                optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            }
            //$scope.setRevisionsForView();
            toaster.pop('success', 'Option Saved', 'Option saved to database');
        }, function(error) {
            toaster.pop('error', 'Option Save Error', error);
        });
    };

    $scope.onSupplierSelect = function(new_supplier) {
        $scope.overridden_materials = $filter('filter')($scope.all_materials, { supplier: new_supplier.name }, true);
        $scope.overridden_categories = [];

        $scope.overridden_materials.forEach(function(material, idx) {
            var in_list = $filter('filter')($scope.overridden_categories, {name: material.category}, true);
            if(in_list.length === 0) {
                $scope.overridden_categories.push({
                    name: material.category
                });
            }
        });
    };

    $scope.onEquipmentSupplierSelect = function(new_supplier) {
        $scope.overridden_equipments = $filter('filter')($scope.all_equipments, { supplier: new_supplier.name }, true);
        $scope.overridden_equipment_categories = [];

        $scope.overridden_equipments.forEach(function(equipment, idx) {
            var in_list = $filter('filter')($scope.overridden_equipment_categories, {name: equipment.category}, true);
            if(in_list.length === 0) {
                $scope.overridden_equipment_categories.push({
                    name: equipment.category
                });
            }
        });
    };

    $scope.deleteMaterial = function(material, index){
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var mat_index = $scope.current_subtask.materials.indexOf(material);

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.materials.splice(mat_index, 1);
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            var saved_opt = $filter('filter')(res.options, {
                'number': option[0].number}, true)[0];

            var opt = $filter('filter')($scope.my_options.options, {
                'number': option[0].number}, true)[0];
            opt = saved_opt;
            $scope.current_option.subtasks = saved_opt.subtasks;
            //$scope.updateCurrentOption();
            // var current_list = $filter('filter')($scope.bid_list, {
            //     'revision': $scope.current_option.bid_revision }, true);

            // $scope.original_bid_subtasks =
            //     tradeOptionsService.getBidSubtasks(
            //         $scope.my_bid, current_list);
            for(var j=0; j<$scope.plans.length; j++) {
                optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });

        $scope.materialEditId = -1;
    };

    $scope.addMaterial = function(material) {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        if(!material) {
            alert('No Material Selected!');
            return;
        }

        var new_mat = ({
            name: material.name,
            supplier: material.supplier,
            description: material.description,
            unit: material.unit.unit,
            trade: material.trade,
            note: material.note,
            units_per_order: Number(material.units_per_order),
            price_per_order: material.price_per_order,
            piece_per_size: material.piece_per_size,
            delivery_price: material.delivery_price,
            delivery_offset: material.delivery_offset,
            isInventory: material.isInventory || false,
            quantity: 0,
            quantity_allowed: 0,
            note: material.note
        });

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.materials.push(new_mat);
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            var saved_opt = $filter('filter')(res.options, {
                'number': option[0].number}, true)[0];

            var opt = $filter('filter')($scope.my_options.options, {
                'number': option[0].number}, true)[0];
            opt = saved_opt;
            $scope.current_option.subtasks = saved_opt.subtasks;
            //$scope.updateCurrentOption();
            // var current_list = $filter('filter')($scope.bid_list, {
            //     'revision': $scope.current_option.bid_revision }, true);

            // $scope.original_bid_subtasks =
            //     tradeOptionsService.getBidSubtasks(
            //         $scope.my_bid, current_list);
            for(var j=0; j<$scope.plans.length; j++) {
                optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            }
            toaster.pop('success', 'Material Added', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Material Not Added', error);
        });

        $scope.materialEditId = -1;

        this.current_material = this.current_category = '';
        if(this.current_material)
          this.current_material.note = '';

        this.new_supplier = this.new_category = this.new_material = '';
    };

    $scope.updateMaterial = function(undef, material) {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        // material represents one of possibly many due
        // to the view.  We only show one subtask but
        // there can be many so we have to look at our
        // original options and then pull subtasks that
        // match our current subtask
        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var mat_index = $scope.current_subtask.materials.indexOf(material);

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.materials[mat_index].piece_per_size = Number(material.piece_per_size);
            sub.materials[mat_index].price_per_order = material.price_per_order;
            sub.materials[mat_index].note = material.note;
            sub.materials[mat_index].unit = (material.unit.unit) ? material.unit.unit : material.unit;
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            var saved_opt = $filter('filter')(res.options, {
                'number': option[0].number}, true)[0];

            var opt = $filter('filter')($scope.my_options.options, {
                'number': option[0].number}, true)[0];
            opt = saved_opt;
            $scope.current_option.subtasks = saved_opt.subtasks;
            // //$scope.updateCurrentOption();  this function is resetting current_subtask
            // var current_list = $filter('filter')($scope.bid_list, {
            //     'revision': $scope.current_option.bid_revision }, true);

            // $scope.original_bid_subtasks =
            //     tradeOptionsService.getBidSubtasks(
            //         $scope.my_bid, current_list);
            for(var j=0; j<$scope.plans.length; j++) {
                optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });

        $scope.materialEditId = -1;
    };

    $scope.supplierModalActivated = function() {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        if(!$scope.available_suppliers) {
            $scope.available_suppliers = [];

            Materials.query({
                'trade_account': $scope.my_trade._id,
                'userId': $scope.main_account_id
             }, function(materials) {
                $scope.all_materials = materials;
                $scope.all_materials.forEach(function(material, idx) {

                    var in_list = $filter('filter')($scope.available_suppliers, {
                        name: material.supplier}, true);
                    if(in_list.length === 0) {
                        $scope.available_suppliers.push({
                            name: material.supplier
                        });
                    }
                });
            });
        }
    };

    $scope.deleteEquipment = function(equipment, index){
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        console.log('deleteEquipment commented out');
        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var eq_index = $scope.current_subtask.equipment.indexOf(equipment);

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.equipment.splice(eq_index, 1);
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            var saved_opt = $filter('filter')(res.options, {
                'number': option[0].number}, true)[0];

            var opt = $filter('filter')($scope.my_options.options, {
                'number': option[0].number}, true)[0];
            opt = saved_opt;
            $scope.current_option.subtasks = saved_opt.subtasks;
            //$scope.updateCurrentOption();
            // var current_list = $filter('filter')($scope.bid_list, {
            //     'revision': $scope.current_option.bid_revision }, true);

            // $scope.original_bid_subtasks =
            //     tradeOptionsService.getBidSubtasks(
            //         $scope.my_bid, current_list);
            for(var j=0; j<$scope.plans.length; j++) {
                optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });

        $scope.equipmentEditId = -1;
    };

    $scope.addEquipment = function(equipment) {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        if(!equipment) {
            alert('No Equipment Selected!');
            return;
        }

        var new_mat = ({
            name: equipment.name,
            supplier: equipment.supplier,
            description: equipment.description,
            unit: equipment.unit.unit,
            trade: equipment.trade,
            note: equipment.note,
            units_per_order: Number(equipment.units_per_order),
            price_per_order: equipment.price_per_order,
            piece_per_size: equipment.piece_per_size,
            delivery_price: equipment.delivery_price,
            delivery_offset: equipment.delivery_offset,
            quantity: 0,
            quantity_allowed: 0,
            price_per_order: equipment.price_per_order,
            piece_per_size: equipment.piece_per_size,
            delivery_price: equipment.delivery_price,
            note: equipment.note
        });

        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.equipment.push(new_mat);
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            var saved_opt = $filter('filter')(res.options, {
                'number': option[0].number}, true)[0];

            var opt = $filter('filter')($scope.my_options.options, {
                'number': option[0].number}, true)[0];
            opt = saved_opt;
            $scope.current_option.subtasks = saved_opt.subtasks;
            //$scope.updateCurrentOption();
            // var current_list = $filter('filter')($scope.bid_list, {
            //     'revision': $scope.current_option.bid_revision }, true);

            // $scope.original_bid_subtasks =
            //     tradeOptionsService.getBidSubtasks(
            //         $scope.my_bid, current_list);
            for(var j=0; j<$scope.plans.length; j++) {
                optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            }
            toaster.pop('success', 'Equipment Added', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Equipment Not Added', error);
        });

        $scope.equipmentEditId = -1;

        this.current_equipment = this.current_category = '';
        if(this.current_equipment)
          this.current_equipment.note = '';

        this.new_supplier = this.new_category = this.new_equipment = '';
    };

    $scope.updateEquipment = function(undef, equipment) {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        // material represents one of possibly many due
        // to the view.  We only show one subtask but
        // there can be many so we have to look at our
        // original options and then pull subtasks that
        // match our current subtask
        var option = $filter('filter')($scope.my_options.options, {
            'number': $scope.current_option.number }, true);

        if(option.length !== 1) {
            alert('Problem');
            return;
        }

        var eq_index = $scope.current_subtask.equipment.indexOf(equipment);

        var subs = $filter('filter')(option[0].subtasks, {
            'time': $scope.current_subtask.time }, true);

        _.each(subs, function(sub) {
            sub.equipment[eq_index].piece_per_size = Number(equipment.piece_per_size);
            sub.equipment[eq_index].price_per_order = equipment.price_per_order;
            sub.equipment[eq_index].note = equipment.note;
            sub.equipment[eq_index].unit = (equipment.unit.unit) ? equipment.unit.unit : equipment.unit;
        });

        taskTotalsService.getSubtaskCalculations(
            subs,
            $scope.my_bid.costs);

        $scope.my_options.$update(function(res) {
            var saved_opt = $filter('filter')(res.options, {
                'number': option[0].number}, true)[0];

            var opt = $filter('filter')($scope.my_options.options, {
                'number': option[0].number}, true)[0];
            opt = saved_opt;
            $scope.current_option.subtasks = saved_opt.subtasks;
            //$scope.updateCurrentOption();  this function is resetting current_subtask
            // var current_list = $filter('filter')($scope.bid_list, {
            //     'revision': $scope.current_option.bid_revision }, true);

            // $scope.original_bid_subtasks =
            //     tradeOptionsService.getBidSubtasks(
            //         $scope.my_bid, current_list);
            for(var j=0; j<$scope.plans.length; j++) {
                optionPlanService.planTotal($scope.plans[j], $scope.current_option,
                    $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
            }
            toaster.pop('success', 'Bid Database', 'Subtask Updated.');
        }, function(error) {
            toaster.pop('error', 'Bid Database', 'Problem saving the subtask data.');
        });

        $scope.equipmentEditId = -1;
    };

    $scope.equipmentSupplierModalActivated = function() {
        if($scope.isOptionActive($scope.current_option.number)) {
            toaster.pop('error', 'Cannot Edit Option',
                'This option is active on at least one lot. Deactivate option in order to edit.');
            return;
        }

        if(!$scope.all_equipments) {
            $scope.all_equipments = [];
            $scope.available_equipment_suppliers = [];

            Equipments.query({ 'trade_account': $scope.my_trade._id }, function(equipments) {
                $scope.all_equipments = equipments;
                $scope.all_equipments.forEach(function(equipment, idx) {

                    var in_list = $filter('filter')($scope.available_equipment_suppliers, {name: equipment.supplier}, true);
                    if(in_list.length === 0) {
                        $scope.available_equipment_suppliers.push({
                            name: equipment.supplier
                        });
                    }
                });
            });
        }
    };

    $scope.editRequest = function() {
        BidRequestEdit.set($scope.bid);
    };

    $scope.buildCurrentOptions = function() {
        var options = [];

        _.each($scope.my_options.options, function(option) {
            option.lots = [];
            _.each($scope.ordered_lots, function(lot) {
                var opt = $filter('filter')(option.lots, {
                    'number': option.number, 'lot': lot.number, 'plan': lot.plan }, true);

                if(opt.length === 0) {
                    if(option.plans.indexOf(lot.plan) !== -1) {
                        option.lots.push({
                            name: option.name,
                            number: option.number,
                            phase: lot.phase,
                            lot: lot.number,
                            plan: lot.plan,
                            active: $scope.doesLotHaveOption(lot, option)
                        });
                    } else {
                        option.lots.push({
                            name: 'NO DATA',
                            phase: lot.phase,
                            lot: lot.number
                        });
                    }
                } else if(opt.length === 1) {
                    // toaster.pop('error', 'Building Options',
                    //     'Found a lot/plan combo in list. Contact Admin.');
                    // return;
                }
            });
        });
    };

    // $scope.saveOption = function() {
    //     $scope.my_options.$update(function(res) {
    //         $rootScope.$broadcast('$updateOptionSubtask', res);
    //         //$scope.updateCurrentOption();
    //         for(var j=0; j<$scope.plans.length; j++) {
    //             optionPlanService.planTotal($scope.plans[j], $scope.current_option,
    //                 $scope.matrix_values, $scope.bid_list, $scope.my_options.options);
    //         }
    //         toaster.pop('success', 'Option Updated');
    //     }, function(error) {
    //         toaster.pop('error', 'Option Update Error', error);
    //     });
    // };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/trades/public/controllers/tradeProjectEditOptions.js